import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {
    TransactionDetailTurnCashList({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/transactionDetailTurnCash/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
